import React from 'react';
import { AppRoutes } from 'routes';
export const App: React.FC = () => {
  return <AppRoutes />;
};
